import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import zhLocale from '@fullcalendar/core/locales/zh-cn';
import { getCookie, jsonHeader } from './base_ext.js';
import {disp_xhr_error} from './ui_tweak.js';
import i18n from '../jssrc/i18n_js_with_locales';

function init_schedule_checkbox(){
    $('#scheduled_checkbox').change(function() {
       toggle_schedule_disp($(this));
    });
    toggle_schedule_disp($('#scheduled_checkbox'));
}

function toggle_schedule_disp(node){
   $('#schedule-info').toggle(node.is(':checked'));
}

function export_scheduled_candidate_to_xlsx(){
    $('#exportbtn-in-form').click();
}

function userFormatResult(user) {
    if (user.loading) return user.text;

    var markup = "<div>"
    markup += "<span>"+ user.name + "</span>&nbsp;&nbsp;";
    markup += "<span>&lt;" + user.email + "&gt;</span>";

    markup += "</div>";
    return markup;
}

function userFormatSelection(user) {
    return user.name || user.text;
}

function init_interviewer_select2(){
    $('#interviewer-select').select2({
        minimumInputLength: 0,
        ajax: {
            url: "/users",
            data: function (params) {
                return {
                    q: params.term, // search term
                    page: params.page,
                    page_limit: 10
                };
            },
            processResults: function (data, params) { // parse the results into the format expected by Select2.
		params.page = params.page || 1;
                var more = (params.page * 10) < data.total_count;
                return { results: data.items, pagination: { more: more}};
            }
        },
        templateResult: userFormatResult, // omitted for brevity, see the source of this page
        templateSelection: userFormatSelection, // omitted for brevity, see the source of this page
        escapeMarkup: function (m) { return m; } // we do not want to escape markup since we are displaying html in results
    });
}
function export_candidate_csv(){
    $('#export-in-form').click();
}

function get_events_extra_params(){
    return $('#event-query-form').serializeArray().reduce(function(m,o){ m[o.name] = o.value; return m;}, {})
}

var interview_calendar = { instance: null};
function init_interviews_calendar(){
  var calendarEl = document.getElementById('interviews-calendar');
  if (calendarEl) {
      interview_calendar.instance = new Calendar(calendarEl, {
          plugins: [ dayGridPlugin, timeGridPlugin ],
          initialView: 'dayGridMonth',
          headerToolbar: {
              left: 'prev,next today',
              center: 'title',
              right: 'dayGridMonth,timeGridWeek,timeGridDay'
          },
	  navLinks: true, // can click day/week names to navigate views
	  events: {
	      url: '/interview_appointments',
	      extraParams: get_events_extra_params
	  },
	  locales: [zhLocale]
      });
      if (i18n.locale !== "zh-CN"){
	  interview_calendar.instance.setOption('locale', 'en');
      }
      interview_calendar.instance.render();
  }
}

function bind_refetch_event_handler(){
     $('#event-query-form').on('submit', function(e) {
         e.preventDefault();
	 if (interview_calendar.instance) interview_calendar.instance.refetchEvents();
    });
}

function bind_change_opening_event(){
    $('#opening-val-candidate a.changeh').click(function(e){
	$(this).parent().hide();
	$(this).closest('span.val').next('span.val').removeClass('hide');
    });
}

$( document).ready(function() {
    init_schedule_checkbox();
    init_interviewer_select2();
    init_interviews_calendar();
    bind_refetch_event_handler();
    bind_change_opening_event();

    $('#export_candidate_csv').click(function(e){ export_candidate_csv(); e.preventDefault(); });
    $('#export_scheduled_candidate_csv').click(function(e){ export_scheduled_candidate_to_xlsx(); e.preventDefault(); });
});
